import React from 'react'
import { AiOutlineWhatsApp } from "react-icons/ai"

export default function Modelo4(props) {
    return (
        <div style={{ width: '700px', display: 'flex', justifyContent: 'space-between', margin:'5px' }}>
            <div
                style={{
                    border: '3px solid black',    
                    width: '357px',
                    height: '235px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    textAlign:'center',
                    marginRight:'2px'
                }}
            >
                <div
                    style={{
                        height: '22%',
                        width: '95%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        marginTop: '5px',
                        border: '1px solid black',
                        borderRadius: ' 15px',
                        paddingBottom: '2px',
                        
                    }}
                >
                    <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap', font: '13px Roboto, sans-serif', fontWeight: 'bold' }}>
                        EMEB "PROFª MARIA BENEDICTA GUIMARÃES"
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '-10px' }}>
                        <div style={{ fontSize: '9pt' }}>(19) 3935-2769</div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <AiOutlineWhatsApp style={{ fontSize: '9pt' }} />
                            <div style={{ fontSize: '9pt' }}>(19) 99955-0173</div>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        height: '78%',
                        width: '95%',
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '5px 0px 3px 0',
                        border: '1px solid',
                        borderRadius: '15px'
                    }}
                >
                    <div
                        style={{
                            fontSize: '22pt',
                            fontWeight: 'bold',
                            height: '80%',
                            width: '100%',
                            flexWrap: 'wrap',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            marginTop: '-5px',
                            marginBottom:'5px',
                            padding:'5px'
                        }}
                    >
                        {props.obj.nomeAluno?.toUpperCase()}
                    </div>
                    <div
                        style={{
                            height: '20%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%'
                        }}
                    >
                        <div style={{ display: 'flex', height: '100%', width: '100%', alignItems: 'flex-end', marginBottom: '5px', justifyContent: 'space-around' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div>Ano/Turma:</div>
                                <div style={{ border: '1px solid black', borderRadius: '15px', padding: '7px', fontSize: '8pt' }}>{props.obj.turma}</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div>Prof:</div>
                                <div style={{ border: '1px solid black', borderRadius: '15px', padding: '7px', fontSize: '8pt' }}>{props.obj.nomeProfessor}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div
                style={{
                    border: '3px solid black',                  
                    width: '357px',
                    height: '235px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    textAlign:'center',
                    marginLeft:'2px'
                }}
            >
                <div
                    style={{
                        height: '22%',
                        width: '95%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        marginTop: '5px',
                        border: '1px solid black',
                        borderRadius: ' 15px',
                        paddingBottom: '2px'
                    }}
                >
                    <div style={{ margin: '2px 0', display: 'flex', flexWrap: 'wrap', font: '13px Roboto, sans-serif', fontWeight: 'bold' }}>
                        EMEB "PROFª MARIA BENEDICTA GUIMARÃES"
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '-10px' }}>
                        <div style={{ fontSize: '9pt' }}>(19) 3935-2769</div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <AiOutlineWhatsApp style={{ fontSize: '9pt' }} />
                            <div style={{ fontSize: '9pt' }}>(19) 99955-0173</div>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        height: '78%',
                        width: '95%',
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '5px 0px 3px 0',
                        border: '1px solid',
                        borderRadius: '15px'
                    }}
                >
                    <div
                        style={{
                            fontSize: '22pt',
                            fontWeight: 'bold',
                            height: '20%',
                            width: '100%',
                            flexWrap: 'wrap',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            marginTop: '15px'
                        }}
                    >
                        {props.obj.saida?.toUpperCase()}
                    </div>
                    <div
                        style={{
                            fontSize: '12pt',
                            height: '20%',
                            width: '100%',
                            flexWrap: 'wrap',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            marginTop: '15px'
                        }}
                    >
                        Prof: {props.obj.nomeProfessor}
                    </div>
                    <div
                        style={{
                            height: '60%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <div style={{ display: 'flex', height: '100%', width: '100%', alignItems: 'flex-end', marginBottom: '5px', justifyContent: 'space-around' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div>Ano/Turma:</div>
                                <div style={{ border: '1px solid black', borderRadius: '15px', padding: '7px', fontSize: '8pt' }}>{props.obj.turma}</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div>RA:</div>
                                <div style={{ border: '1px solid black', borderRadius: '15px', padding: '7px', fontSize: '8pt' }}>{props.obj.RA}</div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div>Validade:</div>
                                <div style={{ border: '1px solid black', borderRadius: '15px', padding: '7px', fontSize: '8pt' }}> Março de {props.obj.anoAtual + 1}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}